import type { GetNotifications200NotificationsItemBasicInfoType } from './getNotifications200NotificationsItemBasicInfoType';

export type GetNotifications200NotificationsItemBasicInfo = {
  /** @nullable */
  content?: string | null;
  /** @nullable */
  createdAt?: string | null;
  id: number;
  type: GetNotifications200NotificationsItemBasicInfoType;
  /** @nullable */
  updatedAt?: string | null;
  userId: number;
};
